var map = {
	"./bg_h2.png": "1faa",
	"./cards.png": "84a2",
	"./icon.png": "f0fc",
	"./img_app.png": "7d4d",
	"./img_game.png": "27cb",
	"./img_index.png": "548a",
	"./main_STOPsumaho.png": "aff3",
	"./main_balloon.png": "b8e7",
	"./main_bmf.png": "653b",
	"./main_bmp.png": "d127",
	"./main_english.png": "cb42",
	"./main_katori.png": "9dbe",
	"./main_mydic.png": "f7a5",
	"./main_owabi.png": "78ae",
	"./main_startup.png": "fdbc",
	"./main_tikoku.png": "f574",
	"./main_warasibe.png": "93be",
	"./main_warikann.png": "d046",
	"./menu_1.png": "490a",
	"./menu_2.png": "5423",
	"./none.png": "20f5",
	"./numbers.png": "162d",
	"./one.png": "1fcf",
	"./three.png": "784e",
	"./title.png": "eb3b",
	"./trump/c1.png": "1a14",
	"./trump/c10.png": "4bc8",
	"./trump/c11.png": "fe55",
	"./trump/c12.png": "2f06",
	"./trump/c13.png": "f052",
	"./trump/c2.png": "a3d7",
	"./trump/c3.png": "fdab",
	"./trump/c4.png": "a87d",
	"./trump/c5.png": "e58a",
	"./trump/c6.png": "549d",
	"./trump/c7.png": "e5e2",
	"./trump/c8.png": "f8cf",
	"./trump/c9.png": "b0df",
	"./trump/d1.png": "f4a4",
	"./trump/d10.png": "1576",
	"./trump/d11.png": "d2f5",
	"./trump/d12.png": "9c30",
	"./trump/d13.png": "8fbe",
	"./trump/d2.png": "f06f",
	"./trump/d3.png": "e4c7",
	"./trump/d4.png": "da33",
	"./trump/d5.png": "dac6",
	"./trump/d6.png": "d426",
	"./trump/d7.png": "c5a0",
	"./trump/d8.png": "7717",
	"./trump/d9.png": "990b",
	"./trump/h1.png": "670d",
	"./trump/h10.png": "78ab",
	"./trump/h11.png": "147d",
	"./trump/h12.png": "3573",
	"./trump/h13.png": "00de",
	"./trump/h2.png": "8d51",
	"./trump/h3.png": "04ed",
	"./trump/h4.png": "1b07",
	"./trump/h5.png": "db12",
	"./trump/h6.png": "a1c9",
	"./trump/h7.png": "9658",
	"./trump/h8.png": "4795",
	"./trump/h9.png": "22d3",
	"./trump/s1.png": "0236",
	"./trump/s10.png": "ef9d",
	"./trump/s11.png": "58cb",
	"./trump/s12.png": "cab0",
	"./trump/s13.png": "a6a6",
	"./trump/s2.png": "acde",
	"./trump/s3.png": "9aeb",
	"./trump/s4.png": "b91d",
	"./trump/s5.png": "4eed",
	"./trump/s6.png": "890d",
	"./trump/s7.png": "7c80",
	"./trump/s8.png": "48e8",
	"./trump/s9.png": "df42",
	"./trump/z01.png": "971a",
	"./trump/z02.png": "7f85",
	"./two.png": "a021"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";